import { QueryClient } from '@tanstack/react-query';
import { createContext } from 'react';
import { type StoreApi } from 'zustand';

import { createAppStateStore, type AppStateStore } from './app-state-store.js';

export const queryClientConfig = {
  defaultOptions: {
    queries: {
      retry: false,
      // Data only changes via explicit mutations — prevent unnecessary refetches.
      staleTime: Infinity,
    },
    mutations: {
      retry: false,
    },
  },
};

/**
 * @internal
 */
export interface AppStateContextValue {
  store: StoreApi<AppStateStore>;
  scope: 'user' | 'app';
  queryClient: QueryClient;
}

// Default store used when no AppStateProvider is present.
// isLoading is false — no provider means no bulk fetch will happen.
const defaultStore = createAppStateStore();
defaultStore.setState({ isLoading: false });

/**
 * @internal
 */
export const AppStateContext = createContext<AppStateContextValue>({
  store: defaultStore,
  scope: 'user',
  queryClient: new QueryClient(queryClientConfig),
});
